<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="introduction overflow-hidden">
    <Row class="introduction-content overflow-hidden">
      <Col class="introduction-img relative clearfix" span="12">
        <div class="img absolute"></div>
        <div class="bar inline-block absolute"></div>
      </Col>
      <Col class="introduction-text" span="12">
        <div class="title">中心介绍</div>
        <div class="bar"></div>
        <div class="content overflow-hidden">
          <div>
            生物样本资源对医学基础科学和转化医学研究具有极高的价值，但目前我国各地及北大内部生物样本库建设存在标准化程度低、样本质量参差不齐，样本利用率低、学科资源碎片化，保障机制缺乏、共享合作积极性不高等问题，这些问题有可能成为我国未来医学发展取得突破的瓶颈，建设一个高水平的智慧生物样本资源中心迫在眉睫。北大智慧生物样本资源中心，作为北大各医院及相关科研院所内部的全方位合作和服务平台，可以为实现资源共享及双一流建设的战略决策提供信息奠定基础；同时，集聚并发挥北大医学资源优势，还可以建成国内乃至国际高水平的生物样本资源共享共用示范中心，为打造“北大医学”品牌做出独特贡献。
          </div>
          <div>
            在此背景下应运而生的“北大智慧生物样本资源中心”，集合北大系统乃至全国各地的生物样本干湿库资源，将已有各个生物样本库信息资源进行规范化的信息展示，建立立体的多层次的系统的查询统计体系、共享策略、及合作机制；建成一个高效的生物样本信息资源共享与服务体系，并以此为基础延申到技术与服务培训平台、转化医学与创新研究平台、质量控制等平台的信息整合建设。
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'introductionComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {
    link(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.introduction {
  background-color: $c-white;
  padding: 5.3125vw 0; //102px 0;

  .introduction-img {
    height: 35.625vw; //684px;
    padding: 0 3.8vw 0 5.68vw; //0 73px 0 109px;
    .img {
      top: 0;
      right: 7.14vw; //137px;
      width: 28.49vw; //547px;
      height: 32.4vw; //622px;
      border-radius: 14px;
      background-image: url('/static/images/background/introduction2.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      z-index: 1;
    }
    .bar {
      bottom: 0;
      right: 3.8vw;
      width: 40.52vw; //778px;
      height: 22.14vw; //425px;
      // margin-top: 23.96vw; //260px;
      background: #46bfb8;
      opacity: 0.1;
      border-radius: 14px;
    }
  }
  .introduction-text {
    padding-left: 4.375vw; //84px;
    .title {
      margin: 1.82vw 0 1.09vw 0; //35px 0 21px 0;
      font-size: 1.46vw; //28px;
      line-height: 2.03vw; //39px;
      color: #111a2e;
    }
    .bar {
      background-color: #46bfb8;
      height: 4px;
      margin-bottom: 6px;
    }
    .content {
      padding-right: 11.67vw; //224px;
      div {
        text-indent: 2em;
        margin-top: 2.1875vw; //42px;
        font-size: 1.04vw; //20px;
        color: #646a77;
        font-family: 'PingFang SC';
      }
    }
  }
}
</style>
